import React from "react";
import Autosuggest from "react-autosuggest";
import "./Form.css";
import "./ChallanForm.css";
import "./AutoSuggest.css";
import "./popup.css";

const FormColumn = (props) => {
  const suggestionScrollPositions = React.useRef({});

  const restoreSuggestionScroll = (node, key) => {
    if (!node) return;

    const scrollTop = suggestionScrollPositions.current[key];
    if (!scrollTop) return;

    const applyScroll = () => {
      node.scrollTop = scrollTop;
    };

    applyScroll();
    if (typeof window !== "undefined" && window.requestAnimationFrame) {
      window.requestAnimationFrame(applyScroll);
      window.requestAnimationFrame(() => window.requestAnimationFrame(applyScroll));
    } else {
      setTimeout(applyScroll, 0);
    }
  };

  return (
    <>
      {props.groupInfo[props.groupName].map(function (info) {
        const shouldShowVerifyButton =
          ["TRL", "ttw", "te"].includes(process.env.REACT_APP_CLIENT) &&
          ((props.formName === "AccountMaster" && info.name === "gst") ||
            (props.formName === "Bilty" &&
              ["consignor_gst", "consignee_gst"].includes(info.name)));

        if (info["type"] === "dropdown")
          return (
            <div className={info["className"]} key={info["name"]}>
              {props.checkVisibilityCondition(info) && <label className={info["labelClassName"]}>{info["label"]}</label>}
              {props.checkVisibilityCondition(info) &&<select
                className={info["inputClassName"]}
                onChange={(newValue) => {
                  props.myFormObj.handleChangeForSelect(newValue, info["name"]);
                }}
                disabled={props.checkDisabledCondition(info)}
                value={props.myFormObj.pageState[info["name"]]}
                ref={(a) =>
                  props.myFormObj.storeInputReferenceForSelect(a, info["name"])
                }
                onKeyPress={(a) => props.myFormObj.onKeyPressForKeyNav(a, info)}
              >
                {info["dropdown_items"].map((dropdown_item) => (
                  <option value={dropdown_item.value} key={dropdown_item.label}>
                    {dropdown_item.label}
                  </option>
                ))}
              </select>}
              {props.myFormObj.internalValidationErrors[info["name"]] && (
                <p>{props.myFormObj.internalValidationErrors[info["name"]]}</p>
              )}
            </div>
          );
        else if (info["type"] === "date")
          return (
            <div className={info["className"]} key={info["name"]}>
              <label className={info["labelClassName"]}>{info["label"]}</label>
              <input
                className={info["inputClassName"]}
                type="date"
                name={info["name"]}
                onChange={(newValue) => {
                  props.myFormObj.handleChange(newValue);
                }}
                disabled={props.checkDisabledCondition(info)}
                value={props.myFormObj.pageState[info["name"]]}
                ref={(a) =>
                  props.myFormObj.storeInputReferenceForSelect(a, info["name"])
                }
                onKeyPress={(a) => props.myFormObj.onKeyPressForKeyNav(a, info, props.myFormObj.pageState)}
              />
              {props.myFormObj.internalValidationErrors[info["name"]] && (
                <p>{props.myFormObj.internalValidationErrors[info["name"]]}</p>
              )}
            </div>
          );
        else
          return (
            <div>
              <div className={info["className"]} key={info["name"]}>
                {props.checkVisibilityCondition(info) && (
                  <label className={info["labelClassName"]}>
                    {info["label"]}
                  </label>
                )}
                {/* <input
                    className={info["inputClassName"]}
                    type={info["type"]}
                    name={info["name"]}
                    placeholder={info["placeHolder"]}
                    value={pageState[info["name"]]}
                    onChange={handleChange}
                  /> */}
                 {props.checkVisibilityCondition(info) && (
                  <>
                  <Autosuggest
                    id={info["name"]}
                    // suggestions={props.myFormObj.suggestions}
                    suggestions={(props.myFormObj.suggestions != undefined) ? props.myFormObj.suggestions : []}
                    onSuggestionsFetchRequested={(a) => {
                      if (info.url || info.suggestionKeyword) {
                        props.myFormObj.onSuggestionsFetchRequestedDebounced(
                          a,
                          (b) =>
                            props.myFormObj.suggestionFetchApi(
                              info,
                              b,
                              props.getAdditionalInfoForSuggestionFetch(info)
                            )
                        );
                      }
                    }}
                    onSuggestionsClearRequested={() =>
                      props.myFormObj.onSuggestionsClearRequested(info)
                    }
                    getSuggestionValue={(suggestion) =>
                      suggestion[info.suggestionKeyword]
                    }
                    onSuggestionSelected={(a, b) =>
                      props.myFormObj.getSuggestionValue(
                        b.suggestion,
                        info,
                        props.myFormObj.performSuggestions,
                        props.myFormObj.updatePageStateForGetSuggestion
                      )
                    }
                    renderSuggestion={(a) =>
                      props.myFormObj.renderSuggestion(a, info)
                    }
                    renderSuggestionsContainer={({ containerProps, children }) => (
                      <div
                        {...containerProps}
                        ref={(node) => {
                          if (typeof containerProps.ref === "function") {
                            containerProps.ref(node);
                          } else if (containerProps.ref) {
                            containerProps.ref.current = node;
                          }
                          restoreSuggestionScroll(node, info["name"]);
                        }}
                        onScroll={(event) => {
                          if (containerProps.onScroll) {
                            containerProps.onScroll(event);
                          }
                          suggestionScrollPositions.current[info["name"]] =
                            event.currentTarget.scrollTop;
                        }}
                      >
                        {children}
                      </div>
                    )}
                    highlightFirstSuggestion={true}
                    ref={(a) => props.myFormObj.storeInputReference(a, false)}
                    inputProps={{
                      placeholder: info["placeholder"],
                      value: String(props.myFormObj.pageState[info["name"]]),
                      onChange: (a, b) => {
                        suggestionScrollPositions.current[info["name"]] = 0;
                        props.myFormObj.onChangeAutoSuggest(a, b, info);
                      },
                      onBlur: () => props.myFormObj.onblurValidator(info),
                      onKeyPress: (a) =>
                        props.myFormObj.onKeyPressForKeyNav(a, info, props.myFormObj.pageState),
                      disabled: props.checkDisabledCondition(info),
                    }}
                  />

                  {shouldShowVerifyButton && (
                    <button
                      type="button"
                      onClick={() => props.handleVerifyGST(info.name)}
                      disabled={
                        typeof props.isVerifying === "boolean"
                          ? props.isVerifying
                          : props.isVerifying?.[info.name]
                      }
                      style={{
                        marginLeft: "8px",
                        padding: "5px 10px",
                        marginBottom: "10px",
                        background: "#1e293b",
                        color: "#fff",
                        borderRadius: "4px",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      {typeof props.isVerifying === "boolean"
                        ? props.isVerifying
                          ? "Verifying..."
                          : "Verify"
                        : props.isVerifying?.[info.name]
                        ? "Verifying..."
                        : "Verify"}
                    </button>
                  )}
                </>
              )}
              {shouldShowVerifyButton &&
                (typeof props.gstError === "string"
                  ? props.gstError
                  : props.gstError?.[info.name]) && (
                  <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                    {typeof props.gstError === "string"
                      ? props.gstError
                      : props.gstError?.[info.name]}
                  </p>
              )}

              {props.myFormObj.internalValidationErrors[info["name"]] && (
                  <p>
                    {props.myFormObj.internalValidationErrors[info["name"]]}
                  </p>
                )}

                {info["name"] === "pan_no" && props.formName === "vehicle" && (
                  <div style={{ display: 'flex', alignSelf: 'flex-start', marginLeft: "10px" }}>
                    <label style={{ display: 'flex', alignItems: 'center', marginLeft: "10px" }}>
                      <input
                        type="checkbox"
                        style={{ width: '20px', height: '20px', marginRight: '10px' }}
                        disabled={props.myFormObj.pageState.is_more_than_ten == "1" && props.myFormObj.pageState.roleId != "1" ? "disabled" : ""}
                        checked={props.myFormObj.pageState.is_more_than_ten == "1"}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          const newTdsRate = isChecked
                            ? (props.myFormObj.pageState.pan_no && props.myFormObj.pageState.pan_no[3] && props.myFormObj.pageState.pan_no[3].toLowerCase() === 'p' ? '1' : '2')
                            : '0';
                          const newIngorePanLimit = isChecked ? '1' : '0';

                          props.myFormObj.setPageState({
                            ...props.myFormObj.pageState,
                            is_more_than_ten: isChecked ? "1" : "0",
                            tds_rate: newTdsRate,
                            ingore_pan_limit: newIngorePanLimit,
                          });
                        }}
                      /> Is More Than 10 Vehicle
                    </label>
                  </div>
                )}

              </div>
              {/* {(info["name"] == "consignor_name" || info["name"] == "consignee_name" ) &&(
                  <div className="form-row">
                    Id of consignor is {props.myFormObj.pageState.consignor_id}
                  </div>
                )} */}
            </div>
          );
      })}
    </>
  );
};

export default FormColumn;
